import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import authService from './services/authService';
import './App.css';
import ProtectedRoute from './components/ProtectedRoute';
import { CLIENT_APP_VERSION } from './config';
import { setSuppressTawkBubble, hideTawk } from './services/tawk';
import NewYearTheme from './components/NewYearTheme';


import Landing from './pages/Landing';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import StartCode from './pages/StartCode';
import TestModule from './pages/TestModule';
import TestDetailedResults from './pages/TestDetailedResults';
import TestLeaderboard from './pages/TestLeaderboard';
import Survey from './pages/Survey';
import Leaks from './pages/Leaks';
import LeaksResults from './pages/LeaksResults';


function AutoLogout() {
  const navigate = useNavigate();
  useEffect(() => {
    let logoutTimer;
    const events = ['click','mousemove','keydown','scroll','touchstart'];
    const resetTimer = () => {
      clearTimeout(logoutTimer);
      logoutTimer = setTimeout(() => {
        authService.logout();
        navigate('/login');
      }, 6 * 60 * 60 * 1000);
    };
    events.forEach(e => window.addEventListener(e, resetTimer));
    resetTimer();
    return () => {
      clearTimeout(logoutTimer);
      events.forEach(e => window.removeEventListener(e, resetTimer));
    };
  }, [navigate]);
  return null;
}

function TawkRouteToggle() {
  const location = useLocation();
  useEffect(() => {
    const isTest = /^\/module\//.test(location.pathname);
    try {
      document.body.classList.toggle('no-tawk', isTest);
    } catch {}
    if (isTest) {
      try { setSuppressTawkBubble(true); } catch {}
      try { hideTawk(); } catch {}
    } else {
      try { setSuppressTawkBubble(false); } catch {}
    }
  }, [location.pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const storedVersion = localStorage.getItem('appVersion');
    if (storedVersion !== CLIENT_APP_VERSION) {
      localStorage.clear();
      document.cookie.split(';').forEach(c => {
        document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date(0).toUTCString() + ';path=/');
      });
      localStorage.setItem('appVersion', CLIENT_APP_VERSION);
      window.location.reload();
    }
  }, []);

  const [userData, setUserData] = useState({ name: '', surname: '' });

  return (
    <Router>
      <AutoLogout />
      <TawkRouteToggle />
      <NewYearTheme />
      <div className="App">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login setUserData={setUserData} />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard userData={userData} /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/start-code" element={<ProtectedRoute><StartCode userData={userData} /></ProtectedRoute>} />
          <Route path="/module/:moduleType/:moduleNumber" element={<ProtectedRoute><TestModule userData={userData} /></ProtectedRoute>} />
          <Route path="/detailed-results/:testId" element={<ProtectedRoute><TestDetailedResults /></ProtectedRoute>} />
          <Route path="/leaderboard/:testId" element={<ProtectedRoute><TestLeaderboard /></ProtectedRoute>} />
          <Route path="/survey" element={<ProtectedRoute><Survey /></ProtectedRoute>} />
          <Route path="/leaks" element={<ProtectedRoute><Leaks /></ProtectedRoute>} />
          <Route path="/leaks/test/:sessionId" element={<ProtectedRoute><TestModule userData={userData} isLeaksMode={true} /></ProtectedRoute>} />
          <Route path="/leaks/results/:sessionId" element={<ProtectedRoute><LeaksResults /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
